import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConsentService {
  // 
  /** Show Consent Dialog. */
  showConsent() {
    return localStorage.getItem("consent") ? false : true;
  }

  /** Return current consent array */
  getAllConcents() {
    return localStorage.getItem("consent") ? localStorage.getItem("consent").split(",") : [true, false];
  }

  /** Accept all cookies */
  acceptAll() {
    localStorage.setItem("consent", "true,true");
  }

  /** Accept selected cookies */
  acceptSelections(selections) {
    localStorage.setItem("consent", selections.join());
  }

  /** Accept only necessary cookies */
  acceptNecessary() {
    localStorage.setItem("consent", "true,false");
  }
}